import React, {useState}  from 'react';
import Modal from '../modal/modal.jsx';
import ErrorMsg from "../error-msg/error-msg";
import Input from "../forms/input/input";
import Button from "../button/button";
import {saveClazz} from "../../api/clazz";
import {showLoading} from "../loading/loading";

const ClazzFormModal = ({id, name, schoolName, schoolCode, onClose, onSubmit, title,desc}) => {
    const [_name, setName] = useState(name || '');
    const [_schoolName, setSchoolName] = useState(schoolName || '');
    const [_schoolCode, setSchoolCode] = useState(schoolCode || '');
    const [_desc, setSchoolDesc] = useState(desc || '');
    const [errorMsg, setErrorMsg] = useState('');
    return (
        <Modal
            onClose={onClose}
            title={title || window.L("teach.class.create.title")}
            >
            <ErrorMsg errorMsg={errorMsg}/>
            <Input
                placeholder={window.L("teach.class.create.inputClassName")}
                onChange={v => {setName(v)}}
                defaultValue={_name}
            />
            <Input
                placeholder={window.L("teach.class.create.inputSchoolName")}
                onChange={v => {setSchoolName(v)}}
                defaultValue={_schoolName}
            />
            <Input
                placeholder={window.L("teach.class.create.inputSchoolDesc")}
                onChange={v => {setSchoolDesc(v)}}
                defaultValue={_desc}
            />
            <Input
                tips={window.L("teach.class.create.inputSchoolCodeTips")}
                placeholder={window.L("teach.class.create.inputSchoolCode")}
                onChange={v => {setSchoolCode(v)}}
                defaultValue={_schoolCode}
            />
            <div style={{textAlign: 'center'}}>
                <Button
                    theme={"submit"}
                    label="提交"
                    onClick={() => {
                        if (_name) {
                            showLoading(window.L('teach.loading.submit'));
                            try {
                                saveClazz({
                                    id: id,
                                    name: _name,
                                    school_name: _schoolName,
                                    desc:_desc,
                                    school_code: _schoolCode
                                }).then(()=>{
                                    if (onSubmit) onSubmit();
                                });
                            }catch (e) {
                                if (e.msg || e.data) {
                                    setErrorMsg(e.msg || e.data);
                                }else {
                                    setErrorMsg(e.toString());
                                }
                            }
                        }else {
                            setErrorMsg(window.L("teach.class.create.classNameEmpty"));
                        }
                    }}
                    />
            </div>
        </Modal>
    );
}

export default ClazzFormModal;
